"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
module.exports = function prettierBytes(input) {
  if (typeof input !== 'number' || Number.isNaN(input)) {
    throw new TypeError("Expected a number, got ".concat(_typeof(input)));
  }
  var neg = input < 0;
  var num = Math.abs(input);
  if (neg) {
    num = -num;
  }
  if (num === 0) {
    return '0 B';
  }
  var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
  var value = Number(num / Math.pow(1024, exponent));
  var unit = units[exponent];
  return "".concat(value >= 10 || value % 1 === 0 ? Math.round(value) : value.toFixed(1), " ").concat(unit);
};